import { type BuyFormFields } from '@components/ui/billId&form/BuyForm.vue';
import type {
    ItineraryPackageFreeServices,
    ItineraryPackageService,
    SubmitBuyerPassenger,
} from '@store/form';
import { PaxType } from '@utils/types';

export function buyFormToPassenger(
    value: BuyFormFields,
    type: PaxType = PaxType.Adult,
    packageOptionalService: ItineraryPackageService[] = [],
    packageFreeService: ItineraryPackageFreeServices[] = [],
    infantSeat?: boolean
): SubmitBuyerPassenger {
    return {
        title: '',
        isDuplicated: value.isDuplicated,
        type,
        gender: value.gender,
        firstName: value.firstName,
        lastName: value.lastName,
        persianLastName: value.persianLastName,
        persianFirstName: value.persianFirstName,
        birthDate:
            value.birthDate &&
            dayConfig.gregory(value.birthDate).format(formatter()),
        passportExpiry:
            value.passportExpiry &&
            dayConfig.gregory(value.passportExpiry).format(formatter()),
        carModel: value.carModel,
        infantSeat,
        nationalCode: value.nationalCode,
        passportNumber: value.passportNumber,
        nationality: value.nationality,
        nationalityCode: value.nationalityCode,
        carPlate: [
            value['carPlate.0'],
            value['carPlate.1'],
            value['carPlate.2'],
            value['carPlate.3'],
            value['carPlate.4'],
        ],
        packageOptionalService,
        packageFreeService,
    };
}
